import type { ObjectiveSummaryRow } from './cockpit-data';

/**
 * Ordering and number formatting for the Objectives tab.
 *
 * Meteoric's version of this file also held the band's row tint and left
 * border. Those are gone from the DATA layer on purpose: this portal's brand
 * has no green and no amber, and a colour decision does not belong beside a
 * sort comparator anyway. The band's tone now lives in `format.ts` with every
 * other tone decision in the module.
 */
export function sortObjectiveSummaryRows(rows: ObjectiveSummaryRow[]): ObjectiveSummaryRow[] {
  return [...rows].sort((left, right) => {
    if (left.profit_yield === null || right.profit_yield === null) {
      if (left.profit_yield === null && right.profit_yield === null) return compareSpend(left, right);
      return left.profit_yield === null ? 1 : -1;
    }
    if (left.profit_yield !== right.profit_yield) return right.profit_yield - left.profit_yield;
    return compareSpend(left, right);
  });
}

export function formatObjectiveProfitYield(value: number | null): string {
  return value === null ? 'n/a' : `${(value * 100).toFixed(0)}%`;
}

function compareSpend(left: ObjectiveSummaryRow, right: ObjectiveSummaryRow): number {
  const leftSpend = left.spend ?? Number.NEGATIVE_INFINITY;
  const rightSpend = right.spend ?? Number.NEGATIVE_INFINITY;
  if (leftSpend !== rightSpend) return rightSpend - leftSpend;
  const objectiveOrder = left.objective.localeCompare(right.objective, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
  return (
    objectiveOrder ||
    (left.campaign_type ?? '').localeCompare(right.campaign_type ?? '', undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  );
}
